:host {
  display: flex;
  grid-column-start: 1;
  grid-column-end: -1;
  margin-inline-start: calc(var(--indent) * (var(--level) - 1));
}

:host::part(selector-label) {
  display: none;
}